import fetch from '../utils/fetch'

// 獲取開屏廣告設定
export function getOpenScreenADSet (query) {
  return fetch({
    url: '/openscreenad/set',
    method: 'get',
    params: query
  })
}

// 儲存開屏廣告設定
export function saveOpenScreenADSet (data) {
  return fetch({
    url: '/openscreenad/set',
    method: 'post',
    params: data
  })
}
